<template>
  <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
  <!-- :::::::::::::::::         DISPOSITIVOS NORMAIS        :::::::::::::::::: -->
  <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
  <div class="back-color">
    <home-topbar />
    <home-first-section />
  </div>
</template>

<script>
import HomeTopBar from "@/components/bars/HomeTopBar";
import HomeFirstSection from "@/components/sections/HomeFirstSection";

export default {
  name: "PaginaPrincipal",

  components: {
    "home-topbar": HomeTopBar,
    "home-first-section": HomeFirstSection,
  },
};
</script>

<style lang="scss" scoped>
.back-color {
  background-color: lightgray;
}
</style>
